import { render, staticRenderFns } from "./shipping-modal.vue?vue&type=template&id=2a6c2ec6&"
import script from "./shipping-modal.vue?vue&type=script&lang=js&"
export * from "./shipping-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports